angular.module('impactx.panel').directive('ixTenderPanel', function () {
    return {
        restrict: 'EA',
        controller: 'TenderPanelCtrl',
        controllerAs: 'tenderPanelCtrl',
        scope: true,
        bindToController: {
            tender: "=",
            currentFilter: "="
        },
        templateUrl: 'shared/panel/templates/tender.panel.tmpl.html'
    }
});